export default "__VITE_ASSET__fbcaecf1__"